export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.312.0-a0ec738",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
